import React from "react";
import { Provider } from "react-redux";
import store from "REDUX/store";
import Router from "../../Routes/Router";
import ShowTostr from "../ShowTostr/ShowTostr";

import "./App.less";

const App = () => {
  return (
    <div className="App">
      <Provider store={store}>
        <ShowTostr />
        <Router />
      </Provider>
    </div>
  );
};

export default App;
